import React, { Component } from 'react';

import AppChrome from '../layout/AppChrome';

import { getUserAndTeam } from '../util/DatabaseUtils';
import { findCurrentTeamChallenge, findLastTeamChallenge, findNextTeamChallenge, getRankForUser, getTotalPointsForUser, rankUsers } from '../util/TeamChallengeUtils';

import moment from 'moment';
import SpinnerPanel from '../ui/SpinnerPanel';
import Avatar from '../ui/Avatar';

const INITIAL_STATE = {
  dataLoaded: false
};

const calendarDateFormat = 'YYYY-MM-DD';

class TeamChallengeLeaderboard extends Component {
  constructor(props) {
    super(props);
    this.state = { ...INITIAL_STATE };
  }

  checkDataLoaded = () => {
    if (this.props.firebase.user && !this.state.dataLoaded) {
      getUserAndTeam(this.props.firebase, (user, team) => {
        const todayFormatted = moment().format(calendarDateFormat);

        this.setState({ 
            dataLoaded: true, 
            user: user, 
            team : team, 
            currentChallenge: findCurrentTeamChallenge(team, todayFormatted),
            nextChallenge: findNextTeamChallenge(team, todayFormatted),
            lastChallenge: findLastTeamChallenge(team, todayFormatted)
         });
      },
      () => {
        this.setState({ isOffline: true })
      })
    }
  }

  renderLeaderboard = () => {
    if (!this.state.dataLoaded) {
      return <SpinnerPanel/>
    }

    if (!this.state.currentChallenge)
      return <p>No current challenge</p>

    if (!this.state.currentChallenge.checkins)
      return <p>No current challenge checkins</p>

    const usersRanked = rankUsers(this.state.currentChallenge);

    var items = []

    usersRanked.forEach((userId) => {
      var member = this.state.team.members[userId];
      if (!member)
        return;

      const rank = getRankForUser(this.state.currentChallenge, userId);
      const points = getTotalPointsForUser(this.state.currentChallenge, userId);

      items.push(
         <div className='teamChallengeLeaderboardItem'>
          <div className='teamChallengeLeaderboardAvatar'><Avatar size='medium' name={member.name} image={member['photoURL']}/></div>
          <div className='teamChallengeLeaderboardRank'>{rank}</div>
          <div className='teamChallengeLeaderboardName'>{member.name}</div>
          <div className='teamChallengeLeaderboardPoints'>{points} POINTS</div>
        </div>
      )
    })

    return items;
  }

  componentWillMount = () => {
    this.checkDataLoaded(false);
  }

  componentDidUpdate = (prevProps, prevState, snapshot) => {
    this.checkDataLoaded(false);
  }

  componentWillUnmount() {}
  
  render = () => {
    var history = this.props.history;

    return (
      <AppChrome title="Leaderboard" history={history} requireLogin={true} user={this.state.user} team={this.state.team} firebase={this.props.firebase} tab="Habits">
        { this.renderLeaderboard() }
      </AppChrome>
    )
  }
}

export default TeamChallengeLeaderboard;